// extracted by mini-css-extract-plugin
module.exports = {"cross":"Cross_cross__1pAup"};